const COLUMN_WIDTH = {
  LARGE: '400PX',
  MEDIUM: '250PX',
  SHORT: '120PX',
};

export default COLUMN_WIDTH;
